import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'

function AccountSelectedTag(props) {

    return (
        <div className="tag account-selected-tag">
            <span>{props.account.accountNumber}</span>
            <span>{props.account.name}</span>
            <span className="tag-button cancel-button">
                <FontAwesomeIcon icon={faTimesCircle} onClick={() => props.cancel(props.account.accountID)}/>
            </span>
        </div>
    );
}

export default AccountSelectedTag;